import docReady from '../../common/docReady';
import code from '../../common/lib/code';

docReady(() => {
  code();
});
